import PageLayout from "../../components/feature/PageLayout";
import HeroSection from "./components/HeroSection";
import ValueSection from "./components/ValueSection";
import SceneSection from "./components/SceneSection";
import GiftTypesSection from "./components/GiftTypesSection";
import FlowSection from "./components/FlowSection";
import DeliverySection from "./components/DeliverySection";
import ValiditySection from "./components/ValiditySection";
import PolicySection from "./components/PolicySection";
import FAQSection from "./components/FAQSection";
import FinalCTA from "./components/FinalCTA";

export default function Gift() {
  return (
    <PageLayout>
      <HeroSection />
      <ValueSection />
      <SceneSection />
      <GiftTypesSection />
      <FlowSection />
      <DeliverySection />
      <ValiditySection />
      <PolicySection />
      <FAQSection />
      <FinalCTA />
    </PageLayout>
  );
}
